import React, { useState } from "react";

import { Card, Typography, Pagination, Table, Popconfirm, message } from "antd";

import { useParams } from "react-router-dom";

import { Tag, Tooltip, Space } from "antd";
import {
  CheckCircleOutlined,
  PlayCircleOutlined,
  UserAddOutlined,
  BarsOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { capitalizeWords } from "../../../../components/icons/ApplicationColor";
import { DeleteTwoTone } from "@ant-design/icons";

import useCommonListing from "../../../../components/AdminComponents/customHooks/useCommonListing";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
import axiosInstance from "../../../../api/Axios";
// import { GetFormattedDateTime } from "../../../../components/utils/DateTimeUtils";

const { Title } = Typography;
const Events = (props) => {
  // eslint-disable-next-line no-unused-vars
  const userInfo = useSelector((state) => state.user);
  const classification = useSelector(
    (state) => state.orgdeatil.customerClassification
  );
  const { id } = useParams();
  const [loadAgain, setLoadAgain] = useState(false);
  const LoadAPI = () => {
    setLoadAgain((prev) => !prev);
  };
  const [messageApi, contextHolder] = message.useMessage();
  const {
    data,
    itemsLength,
    loading,
    filterData,
    onShowSizeChange,
    onPageChange,
    handleSearchChange,
    // setFilterData,
    // handleSwitchChange,
    // handleClearAll,
    // setFilterUrl,
  } = useCommonListing({
    passSize: 10,
    passPage: 1,
    passURL: `/customer/event/?organization_id=${id}`,
    loadAgain: loadAgain,
  });
  // eslint-disable-next-line no-unused-vars
  const { pageSize, currentPage, active, filter_url } = filterData;

  const DeleteSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "User has been removed successfully.",
      duration: 5,
    });
    props?.LoadUser();
    LoadAPI();
  };
  const DeleteFalied = () => {
    messageApi.open({
      type: "error",
      content: "Failed to remove User.",
      duration: 5,
    });
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const handleDelete = async (record) => {
    if (false) {
      try {
        await axiosInstance.delete(
          `/learn/bundleuserdelete/${record?.bundle_course_id}/${record?.user_id}/`,
          {
            headers: {
              "X-CSRFToken": csrfToken,
            },
          }
        );
        DeleteSuccessfull();
      } catch (err) {
        DeleteFalied();
      }
    }
  };
  const columns = [
    {
      title: "Event ID",
      dataIndex: "event_id",
      key: "event_id",
      width: 120,
    },
    {
      title: "Event Name",
      dataIndex: "name",
      key: "name",
      width: 150,
    },
    {
      title: "Course ID",
      dataIndex: "course_id",
      key: "course_id",
      width: 120,
    },
    {
      title: "Course Name",
      dataIndex: "course_name",
      key: "course_name",
      width: 150,
      ellipsis: true,
    },

    ...(false
      ? [
        {
          title: "Progress Summary",
          key: "progress_summary",
          render: (text, record) => {
            const {
              completed_count,
              enroled_count,
              started_count,
              total_count,
            } = record;

            return (
              <Space size="small" direction="vertical">
                <Space wrap>
                  <Tooltip title="Total Assigned">
                    <Tag
                      icon={<BarsOutlined />}
                      color="default"
                      style={{ fontSize: "13.25px" }}
                    >
                      {total_count}
                    </Tag>
                  </Tooltip>
                  <Tooltip title="Enrolled">
                    <Tag
                      icon={<UserAddOutlined style={{ color: "blue" }} />}
                      color="default"
                      style={{ fontSize: "13.25px" }}
                    >
                      {" "}
                      {enroled_count}
                    </Tag>
                  </Tooltip>
                  <Tooltip title="Started">
                    <Tag
                      icon={
                        <PlayCircleOutlined style={{ color: "#ec7a1c" }} />
                      }
                      color="default"
                      style={{ fontSize: "13.25px" }}
                    >
                      {" "}
                      {started_count}
                    </Tag>
                  </Tooltip>
                  <Tooltip title="Completed">
                    <Tag
                      icon={
                        <CheckCircleOutlined style={{ color: "green" }} />
                      }
                      color="default"
                      style={{ fontSize: "13.25px" }}
                    >
                      {" "}
                      {completed_count}
                    </Tag>
                  </Tooltip>
                </Space>
              </Space>
            );
          },
          width: 280,
        },
      ]
      : []),
    {
      title: "Start Date",
      dataIndex: "start_date",
      key: "start_date",
      width: 100,
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      key: "end_date",
      width: 100,
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      width: 130,
    },
    // {
    //   title: "End Time",
    //   dataIndex: "end_time",
    //   key: "end_time",
    //   width: 100,
    // },
    // {
    //   title: "Department",
    //   dataIndex: "department_name",
    //   key: "department_name",
    //   width: 250,
    //   ellipsis: true,
    //   render: (text, record) => (
    //     <div>{record?.organization?.department?.dep_name || ""}</div>
    //   ),
    // },

    ...(true
      ? [
        {
          title: "Actions",
          dataIndex: "id",
          key: "id",
          align: "center",
          width: 100,
          fixed: "right",
          render: (text, record) => (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Popconfirm
                title={"Delete User"}
                description=" "
                onConfirm={() => handleDelete(record)}
                // onCancel={cancel}
                okText="Yes"
                cancelText="No"
                placement="leftTop"
              >
                <DeleteTwoTone
                  style={{
                    cursor: "pointer",
                    fontSize: "1.6rem",
                    marginLeft: "0.7rem",
                  }}
                  title="Archive"
                  twoToneColor="#eb2f96"
                />
              </Popconfirm>
            </div>
          ),
        },
      ]
      : []),
  ];
  //   const { data: data2 } = useCommonListing({
  //     passSize: 100,
  //     passPage: 1,
  //     passURL: `learn/bundledetailslist/?bundle_id=${id}`,
  //   });
  //   console.log(data2);
  return (
    <Card style={{ width: "100%", marginBottom: "10px" }} hoverable>
      {contextHolder}
      <Title level={5} style={{ marginInline: "10px" }}>
        Associated Events Summary
      </Title>
      <CommonTopDetails
        title={`${classification ? capitalizeWords(classification) : "Customer"} Events`}
        titleSuffix={`${itemsLength || 0} event(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={false}
        filterAction={false}
        marginPass="15px"
        paddingInlinepass="10px"
        topSizeAdd="5px"
        addButtonProps={{
          modalType: "PopUP",
          modalProps: () => {},
        }}
      />
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        size="small"
        loading={loading}
        className="table-container"
        style={{ margin: "1rem" }}
        pagination={false}
        scroll={{
          x: 400,
        }}
        bordered
      />

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "1rem",
        }}
      >
        <Pagination
          size="small"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          pageSizeOptions={["5", "10", "15", "20", "50"]}
          //   showQuickJumper
          current={currentPage}
          defaultPageSize={pageSize}
          total={itemsLength}
        />
      </div>
    </Card>
  );
};

export default Events;
